import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({ selector: '[appReportDetailsTemplate]' })
export class ReportDetailsTemplateDirective {
  template = inject<TemplateRef<any>>(TemplateRef);
}
